import { call, put } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import { ISitecoreResponse } from "~/api/response-types/types";
import { ErrorHandlingActionTypes } from "~/store/reducers/error-handling/error-handling-types";

export function* handleErrorSaga<TPayload>(
    response: ISitecoreResponse<TPayload>,
    rejectForm?: (e?: SubmissionError) => void
) {
    let submissionError;

    if (response.showErrorInModal) {
        yield call(showInModalStrategy, response);
    } else if (response.errorMessage) {
        submissionError = new SubmissionError({
            errorMessage: response.errorMessage,
            errorSeverity: response.errorSeverity
        });
    } else if (response.payload) {
        submissionError = new SubmissionError(response.payload);
    } else {
        yield call(showSilentStrategy, response);
    }

    if (rejectForm) {
        rejectForm(submissionError);
    }
}

export function* showInModalStrategy<TPayload>(error: ISitecoreResponse<TPayload>) {
    yield put({ type: ErrorHandlingActionTypes.SET_ERROR_SEVERITY_TYPE, payload: error });
    yield put({ type: ErrorHandlingActionTypes.SHOW_ERROR_MODAL, payload: error });
}

function* showSilentStrategy<TPayload>(error: ISitecoreResponse<TPayload>) {
    yield console.error(`Silent (${error.errorSeverity}) ---> ${error.errorCode}: ${error.errorMessage}`);
}
